// General sub-reducer for the pad-initialization feature.
// Manages top-level state fields: fetchStatus, submitStatus, padVisitId, padVisit, pad, steps.
// It also handles actions that don't belong to a specific nested slice.

import types from 'app/redux/features/pad-initialization/actions/padInitialization.types';
import {
  ACTION_TYPES,
  getAsyncActionTypeFulfiled,
  getAsyncActionTypePending,
  getAsyncActionTypeReject
} from 'app/redux/features/pad-initialization/actions/padInitialization.types';
import STATUS from '../constants/status.constant';

const { FETCH_PAD_DATA, FETCH_PAD_VISIT_DATA, SUBMIT_INITIALIZATION } = ACTION_TYPES;

const initialState = () => ({
  fetchStatus: STATUS.IDLE,
  submitStatus: STATUS.IDLE,
  padVisitId: null,
  padVisit: {},
  pad: {},
  steps: []
});

const reducer = (state = initialState(), action) => {
  switch (action.type) {
    // Async: Fetch Pad Data (Client)
    case getAsyncActionTypePending(FETCH_PAD_DATA):
      return { ...state, fetchStatus: STATUS.LOADING };
    case getAsyncActionTypeReject(FETCH_PAD_DATA):
      return { ...state, fetchStatus: STATUS.FAILED };
    case getAsyncActionTypeFulfiled(FETCH_PAD_DATA):
      return { ...state, fetchStatus: STATUS.SUCCEEDED, pad: action.payload };

    // Async: Fetch Pad Visit Data (Cooperative)
    case getAsyncActionTypePending(FETCH_PAD_VISIT_DATA):
      return { ...state, fetchStatus: STATUS.LOADING };
    case getAsyncActionTypeReject(FETCH_PAD_VISIT_DATA):
      return { ...state, fetchStatus: STATUS.FAILED };
    case getAsyncActionTypeFulfiled(FETCH_PAD_VISIT_DATA): {
      const padVisit = action.payload;
      return {
        ...state,
        fetchStatus: STATUS.SUCCEEDED,
        padVisit,
        padVisitId: padVisit && padVisit.id ? padVisit.id : null,
        pad: padVisit && padVisit.pad ? padVisit.pad : {}
      };
    }

    // Async: Initialize Pad (Submit)
    case getAsyncActionTypePending(SUBMIT_INITIALIZATION):
      return { ...state, submitStatus: STATUS.LOADING };
    case getAsyncActionTypeReject(SUBMIT_INITIALIZATION):
      return { ...state, submitStatus: STATUS.FAILED };
    case getAsyncActionTypeFulfiled(SUBMIT_INITIALIZATION):
      return { ...state, submitStatus: STATUS.SUCCEEDED };

    // Simple actions
    case types.SET_INITIALIZATION_STEPS:
      return { ...state, steps: action.payload };

    // case types.SET_HOSPITAL_RELEASE_PREVISION:
    //   // Pass-through: handled by hospitalReleasePrevision reducer
    //   return state;

    // case types.DISCHARGE_PATIENT:
    //   // Pass-through: handled by dischargePatient reducer
    //   return state;

    // case types.UPDATE_SCHEDULE_PRESCRIPTION:
    //   // Pass-through: handled by schedulePrescriptions reducer
    //   return state;

    // case types.SELECT_AND_UPDATE_DATA:
    //   // Pass-through: handled by scheduleVisits and scheduleImplantation reducers
    //   return state;

    // case types.SET_SUSPENSION_VISITS:
    //   // Pass-through: handled by suspensionVisits reducer
    //   return state;

    case types.RESET:
      return initialState();

    default:
      return state;
  }
};

export default reducer;
